export default function formatBorrowerName(borrower) {
  return borrower.TIN_type === 'EIN'
    ? borrower.entity_name
    : `${borrower.first_name || ''} ${borrower.last_name || ''}`;
}
